import animateScrollTo from 'animated-scroll-to';

export const getTime = () => {

  // var d = new Date();
  // var datetext = d.toTimeString();
  // datetext = datetext.split(' ')[0];
  // return datetext;

  let today = new Date();
  let h = today.getHours();
  let m = today.getMinutes() < 10 ? '0' + today.getMinutes() : today.getMinutes();
  return h + ':' + m;
}

export const scrollToTop = () => {
  animateScrollTo(document.body.scrollHeight, { speed: 2000 }).then(hasScrolledToPosition => {
    // scroll animation is finished
    // console.log('scroll animation is finished');
    // "hasScrolledToPosition" indicates if page/element
    // was scrolled to a desired position
    // or if animation got interrupted
    if (hasScrolledToPosition) {
      // page is scrolled to a desired position
      // console.log('page is scrolled to a desired position');
    } else {
      // scroll animation was interrupted by user
      // or by another call of "animateScrollTo"
      // console.log('scroll animation was interrupted by user');
    }
  });
}

export const eventsDataLayer = (type, value) => {
  let obj = {}
  obj.event = type;
  if (type == 'chatbot_cta') {
    let utm_campaign = new URLSearchParams(window.location.search).get('utm_campaign');
    if (utm_campaign && utm_campaign == 'chatbot-FA') {
      obj.eventCategory = 'Fissa Appuntamento'
    } else if (utm_campaign && utm_campaign == 'chatbot-DS_FA') {
      obj.eventCategory = 'richiestaPrestito'
    } else {
      obj.eventCategory = ''
    }
    obj.eventAction = 'Chatbot CTA'
    obj.eventLabel = value
  } else if (type == 'customPageview') {
    obj.virtualPageURL = value
  }

  try {
    return window.dataLayer.push(obj);
  } catch (error) {

  }
}